var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoto(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 129,
    height: 129,
    viewBox: "0 0 129 129",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M86 5.375C88.9685 5.375 91.375 7.78147 91.375 10.75V16.1196L118.25 16.125V48.375L107.392 48.3696L122.264 89.1995C123.144 91.5472 123.625 94.0897 123.625 96.7447C123.625 108.619 113.999 118.245 102.125 118.245C92.1103 118.245 83.6948 111.397 81.3048 102.129L58.4466 102.129C56.0584 111.4 47.6417 118.25 37.625 118.25C27.1713 118.25 18.4602 110.789 16.5256 100.902C13.0912 99.1098 10.75 95.5158 10.75 91.375V64.5H59.125C59.125 67.2565 61.2 69.5284 63.8732 69.8388L64.5 69.875H75.25C78.0065 69.875 80.2783 67.8 80.5888 65.1268L80.625 64.5V16.125H64.5V5.375H86ZM37.625 86C31.6879 86 26.875 90.8129 26.875 96.75C26.875 102.687 31.6879 107.5 37.625 107.5C43.5621 107.5 48.375 102.687 48.375 96.75C48.375 90.8129 43.5621 86 37.625 86ZM102.125 86C96.1879 86 91.375 90.8129 91.375 96.75C91.375 102.687 96.1879 107.5 102.125 107.5C108.062 107.5 112.875 102.687 112.875 96.75C112.875 90.8129 108.062 86 102.125 86ZM53.75 16.125C56.7185 16.125 59.125 18.5315 59.125 21.5V59.125H10.75V21.5C10.75 18.5315 13.1565 16.125 16.125 16.125H53.75ZM107.5 26.875H91.375V37.625H107.5V26.875ZM48.375 26.875H21.5V32.25H48.375V26.875Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoto);
export default __webpack_public_path__ + "static/media/moto.db9cf75f439ba00114a5f7ab57b92faa.svg";
export { ForwardRef as ReactComponent };